import { Component, InjectionToken, Type } from '@angular/core';

export const MAX_LENGTH_BUILDING_REPORT_DESCRIPTION = 4000;

export const CUSTOM_BUILDING_REPORT_CONTENT_COMPONENT = new InjectionToken<Type<Component>>(
  'Custom building report content component'
);
